import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchFlowVersions, setFlowVersions, setFlowIsLoading, setSavedFlow, setIsChangingFlowMode } from "redux/actions/flowDesigner/flowsActionCreator";
import { deleteFlowVersion, changeFlowMode } from "api/FlowVersions";
import { toast } from "react-toastify";

const useFlowVersions = (flow_id, shouldFetch = true) => {
   const { user } = useAuth0();
   const { currentSavedFlow, flowVersions, isLoadingFlowVersions } = useSelector((store) => store?.designer?.flows);
   const dispatch = useDispatch();

   const deleteFlowVersionById = async (flow_id, version) => {
      try {
         const deleteFlowVersionResponse = await deleteFlowVersion(flow_id, version, user.stripeId);
         if (deleteFlowVersionResponse?.isSuccessful) {
            toast.success("Flow version deleted successfully");
            const updatedFlowVersions = flowVersions.filter((flowVersion) => flowVersion.version !== version);
            dispatch(setFlowVersions(updatedFlowVersions));
            return deleteFlowVersionResponse;
         } else {
            toast.error("Failed to delete flow version");
            console.error("Error deleting flow version", deleteFlowVersionResponse?.message);
            return null;
         }
      } catch (error) {
         toast.error("Failed to delete flow version");
         console.error("Error deleting flow version", error);
         return null;
      }
   };

   const changeMode = async () => {
      try {
         const mode = currentSavedFlow?.shared_status === "active" ? "draft" : "active";

         const changeFlowModeResponse = await changeFlowMode(user?.stripeId, currentSavedFlow?.id, mode);

         if (changeFlowModeResponse.isSuccessful) {
            toast.success("Flow mode changed successfully!");
            dispatch(setFlowVersions(flowVersions.map((v) => (v.version === currentSavedFlow.current_version ? currentSavedFlow : v))));
            dispatch(
               setSavedFlow({
                  ...currentSavedFlow,
                  shared_status: mode
               })
            );
         } else {
            toast.error("Failed to change flow mode.");
         }
         dispatch(setIsChangingFlowMode(true));
         dispatch(setFlowIsLoading(false));
      } catch (error) {
         toast.error("Failed to change flow mode");
         console.error("Error changing flow mode", error);
         return null;
      }
   };

   const handleFetchFlowVersions = () => {
      if (user && flow_id) {
         dispatch(fetchFlowVersions(user?.stripeId, flow_id));
      } else if (user && currentSavedFlow?.id) {
         dispatch(fetchFlowVersions(user?.stripeId, currentSavedFlow?.id));
      }
   };

   useEffect(() => {
      if (!shouldFetch) return;

      handleFetchFlowVersions();
   }, [user, currentSavedFlow?.id, flow_id, shouldFetch]);

   return { flowVersions, isLoadingFlowVersions, deleteFlowVersionById, changeMode, handleFetchFlowVersions };
};

export default useFlowVersions;
